module.exports = __webpack_public_path__ + "assets/img/station27.9ed37dfb.png";